import { OrderScreen } from '../features/account/OrderScreen'

export function OrderPage() {
  return <OrderScreen />
}
